import $ from "jquery";

export default {
  methods: {
    getplaceInfo(placesinfo, distance, ableToBuy, shippingPrice) {
      return (
        placesinfo +
        ` (${distance} Km)` +
        `<div style="margin-top: 5px;border-radius: 5px;padding: 5px; color: white; background: ${
          ableToBuy ? "green" : "red"
        }">${ableToBuy ? ` ค่าส่ง ${shippingPrice} บาท` : " ไม่สามารถจัดส่งได้"}</div>`
      );
    },
    formatProducts(products, categories) {
      var product_by_index = {};
      products.forEach((val, index) => {
        products[index].price = parseFloat(products[index].price);
        products[index].discountprice = parseFloat(products[index].discountprice);
        products[index].isOutOfStock = false;

        if (categories) {
          var categoryIndex = categories.findIndex((x) => x.id === products[index].categoryid);

          if (categoryIndex != -1) {
            categories[categoryIndex].productCount++;
          }
        }
        if (products[index].productstock && products[index].productstock.length > 0) {
          var haveStock = false;
          val.productstock.forEach(function(pval, pindex) {
            if (parseInt(products[index].productstock[pindex][2]) > 0) {
              haveStock = true;
            }

            var price = 0;
            var discount = 0;

            if (pval[3] == null && pval[4] == null) {
              price = parseFloat(val.price);
              discount = parseFloat(val.discountprice);
            } else {
              if (pval[3] == null) {
                price = parseFloat(val.price);
              } else {
                price = parseFloat(products[index].productstock[pindex][3]);
              }

              if (pval[4] == null) {
                discount = products[index].productstock[pindex][3];
              } else {
                discount = parseFloat(products[index].productstock[pindex][4]);
              }
            }

            products[index].productstock[pindex][3] = price;

            products[index].productstock[pindex][4] = discount;
          });

          if (!haveStock) {
            products[index].isOutOfStock = true;
          }
        } else {
          products[index].isOutOfStock = true;
        }
        if (val) {
          product_by_index[val.id] = val;
        }
      });

      return {
        products: products,
        product_by_index: product_by_index,
      };
    },
    calculateBundlePrice: function(price, quantity, productbundle) {
      var prodprice_total = 0;
      var isFound = false;
      $.each(productbundle, function(index, bundle) {
        if (bundle.maxquantity >= quantity && quantity >= bundle.minquantity) {
          prodprice_total = parseFloat(bundle.price);
          isFound = true;
          return;
        }
      });
      if (isFound) {
        return prodprice_total;
      } else {
        return parseFloat(price);
      }
    },
    checkProductStock: function(stock, product) {
      if (stock.length == 0) {
        return null;
      }

      let option = null;
      $.each(stock, function(index, val) {
        if (val[1] == product.option) {
          option = val;
        }
      });

      return option;
    },
    goToErrorInput: function() {
      var vm = this;
      $.each(vm.$validator.errors.items, function(index, error) {
        if (vm.$el.querySelector('[data-vv-name="' + error.field + '"]')) {
          vm.$nextTick(function() {
            vm.$el.querySelector('[data-vv-name="' + error.field + '"]').scrollIntoView();
          });
          return false;
        } else if (vm.$el.querySelector('[name="' + error.field + '"]')) {
          vm.$nextTick(function() {
            vm.$el.querySelector('[name="' + error.field + '"]').scrollIntoView();
          });
          return false;
        }
      });
    },
  },
};
